// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialLinkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.824 4.227c0 1.238-.93 2.23-2.424 2.23h-.03C2.93 6.456 2 5.464 2 4.226 2 2.962 2.959 2 4.43 2c1.464 0 2.364.962 2.394 2.227zM2.253 8.216H6.54V21.11H2.253zM17.712 21.11v-6.899c0-1.733-.618-2.915-2.17-2.915-1.183 0-1.89.796-2.2 1.568-.113.275-.142.658-.142 1.044v7.202H8.912s.059-11.685 0-12.895H13.2v1.828c.57-.878 1.588-2.131 3.865-2.131 2.823 0 4.935 1.843 4.935 5.804v7.394zM13.17 10.085h.029v-.042a.167.167 0 0 1-.03.042z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialLinkedin;
